import { Col, Row } from 'react-dsgov';
import { IVendaDireta } from '../../../../../../../../../interfaces/IBaseDeCalculo';
import styles from './operacaoVendaFormReadOnly.module.scss';
import { formatarCNPJOrCpf } from '../../../../../../../../../utils/formatCNPJOrCPF';
import { ETipoOperacaoVendaDireta, TipoOperacaoVendaDiretaDetalhe } from 'enums/ETipoOperacaoVendaDireta';

interface ITitularArrendatarioOperacaoVendaFormReadOnlyProps {
  vendaDireta: IVendaDireta | undefined;
}

const OperacaoVendaFormReadOnly: React.FC<ITitularArrendatarioOperacaoVendaFormReadOnlyProps> = ({ vendaDireta }) => {
  return (
    <div className={styles.container}>
      <Row className={styles.row}>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Operação</span>
          <span className={styles.dadoAdicionado}>
            {vendaDireta?.tipoOperacao
              ? ETipoOperacaoVendaDireta[vendaDireta.tipoOperacao as unknown as keyof typeof ETipoOperacaoVendaDireta]
              : ''}
          </span>
        </Col>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>CPF/CNPJ</span>
          <span className={styles.dadoAdicionado}>{formatarCNPJOrCpf(vendaDireta?.cpfCnpj || '-')}</span>
        </Col>
        <Col className={styles.dadosCol}>
          <span className={styles.label}>Nome/Razão Social</span>
          <span className={styles.dadoAdicionado}>{vendaDireta?.nomeRazaoSocial || ''}</span>
        </Col>
      </Row>
    </div>
  );
};

export default OperacaoVendaFormReadOnly;
